import React from "react";
import Button from "react-bootstrap/Button";
import { Link, useNavigate } from "react-router-dom";

const NavigateBackButton = () => {
  const navigate = useNavigate();
  return (
    <Button className="btn btn-light btn-xs" onClick={() => navigate(-1)}>
      <i className="bi bi-backspace fs-5 me-2" />
      BACK
    </Button>
  );
};

export default NavigateBackButton;
